exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:1200px){.v-application .phone-no-login-form[data-v-3b98c7fd]{margin-top:30px!important}}@media only screen and (max-width:700px){.v-application .phone-no-login-form[data-v-3b98c7fd]{margin-top:66px!important}}@media only screen and (min-width:1300px){.flex.lg5.custom-lg4[data-v-3b98c7fd]{-ms-flex-preferred-size:33.3333333333%;flex-basis:33.3333333333%;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;max-width:33.3333333333%}}", ""]);

// exports
